module.exports = __webpack_public_path__ + "static/media/10H.c6339410.svg";